import { render, staticRenderFns } from "./copy-import.vue?vue&type=template&id=2ec98461"
import script from "./copy-import.vue?vue&type=script&lang=js"
export * from "./copy-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports